import apiClient from "../api/apiClient";
import { ENDPOINTS } from "../api/endPoints";
import { createDogFormData } from "../models/dogModel";

export const createDogProfile = async (newUserId, dogData, userData) => {
  try {
    const dogPayload = createDogFormData(newUserId, dogData, userData);

    console.log("===== DOG FORM DATA PAYLOAD =====");
    for (const [key, value] of dogPayload.entries()) {
      console.log(key, value);
    }

    const response = await apiClient.post(ENDPOINTS.REGISTER_DOG, dogPayload);

    console.log("Status code:", response.status);
    console.log("Response data:", response.data);
    return response.data;
  } catch (error) {
    console.error("Dog creation failed", error);
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error("Failed to create dog profile.");
  }
};

export const updateDogProfile = async (
  dogId,
  newUserId,
  dogData,
  userData,
) => {
  try {
    const dogPayload = createDogFormData(newUserId, dogData, userData);

    const response = await apiClient.put(
      `/dogs/update-dog-by-id/${dogId}`,
      dogPayload,
    );
    return response.data;
  } catch (error) {
    console.error("Dog update failed", error);
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error("Failed to update dog profile.");
  }
};
